"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApiChatClient = void 0;
const ApiSubClient_1 = require("../../common/client/ApiSubClient");
class ApiChatClient extends ApiSubClient_1.ApiSubClient {
    constructor(chatUrl, adminLinks, axios) {
        super(adminLinks, axios);
        this.chatUrl = chatUrl;
    }
    async doChat(request, abortSignal) {
        const it = await this.axios.post(`${this.chatUrl}/v2/chat`, {
            model: request.model,
            chat_history: request.chatHistory,
            conversation_id: request.conversationId,
        }, {
            headers: {
                'Content-Type': 'application/json',
            },
            signal: abortSignal,
        });
        const data = it.data;
        return {
            answer: data.answer,
            clips: data.clips
                ? Object.fromEntries(Object.entries(data.clips).map(([clipId, clip]) => [
                    clipId,
                    {
                        clipName: clip.clip_name,
                        videoId: clip.video_id,
                        clipId: clip.clip_id,
                        startTime: clip.start_time,
                        endTime: clip.end_time,
                        clipDuration: clip.clip_duration,
                    },
                ]))
                : {},
            conversationId: data.conversation_id,
            messageId: data.message_id,
        };
    }
    async sendClipFeedback(request, abortSignal) {
        const it = await this.axios.post(`${this.chatUrl}/v2/feedback/clip`, {
            chat_history: request.chatHistory,
            conversation_id: request.conversationId,
            feedback_message: request.feedbackMessage,
            clip_id: request.clipId,
            selected_option_id: request.selectedOptionId,
        }, {
            headers: {
                'Content-Type': 'application/json',
            },
            signal: abortSignal,
        });
        return it.data;
    }
    async sendMessageFeedback(request, abortSignal) {
        const it = await this.axios.post(`${this.chatUrl}/v2/feedback/message`, {
            chat_history: request.chatHistory,
            model: request.model,
            conversation_id: request.conversationId,
            agent_reply: request.agentReply,
            feedback_message: request.feedbackMessage,
            thumbs_up: request.thumbsUp,
        }, {
            headers: {
                'Content-Type': 'application/json',
            },
            signal: abortSignal,
        });
        return it.data;
    }
    async getClipFeedbackOptions() {
        const response = await this.axios.get(`${this.chatUrl}/v2/feedback/clip/options`);
        return response.data;
    }
}
exports.ApiChatClient = ApiChatClient;
//# sourceMappingURL=ApiChatClient.js.map